/**
 * Serviço para envio de eventos via Meta Conversions API (CAPI)
 */

const TOKEN = import.meta.env.VITE_TOKEN_META;
const PIXEL_ID = import.meta.env.VITE_META_PIXEL_ID;
const API_VERSION = 'v19.0';
const URL = `https://graph.facebook.com/${API_VERSION}/${PIXEL_ID}/events?access_token=${TOKEN}`;

export const sendMetaEvent = async (eventName, customData = {}, userData = {}) => {
  if (!TOKEN || !PIXEL_ID) {
    console.warn('Meta CAPI: Token ou Pixel ID não configurados.');
    return;
  }

  const payload = {
    data: [
      {
        event_name: eventName,
        event_time: Math.floor(Date.now() / 1000),
        action_source: "website",
        event_source_url: window.location.href,
        user_data: {
          client_user_agent: navigator.userAgent,
          ...userData
        },
        custom_data: {
          ...customData
        }
      }
    ]
  };

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Erro ao enviar evento para Meta CAPI:', error);
  }
};